import React from 'react'

import { Radio, Icon } from 'antd'

import colors from '../../../../components/hocs/colors'
import { toTestId } from '../../../../utils/testing'

const SkillSorter = ({
  selectedSkillsFilter,
  onChangeSkillsType,
  skillsSortOptions,
  isActiveTab = true,
}) => {
  return (
    <div>
      <Radio.Group onChange={e => onChangeSkillsType(e.target.value)} disabled={!isActiveTab}>
        {skillsSortOptions.map(skillSortOption => {
          const { color, displayName, iconType, propertyName } = skillSortOption
          return (
            <span key={displayName} data-testid={`${toTestId(displayName)}-button-sort`}>
              <Radio.Button
                checked={selectedSkillsFilter === propertyName}
                value={propertyName}
                disabled={!isActiveTab}
                tabIndex={isActiveTab ? 0 : -1}
                style={{
                  color: colors.blue3,
                }}
              >
                <Icon
                  type={iconType}
                  style={{
                    color,
                    fontSize: 18,
                    opacity: 0.8,
                    verticalAlign: '0.15em',
                  }}
                  aria-hidden="true"
                />
                <span className="legend-label">{displayName}</span>
              </Radio.Button>
            </span>
          )
        })}
      </Radio.Group>
    </div>
  )
}

export default SkillSorter
